import { render, staticRenderFns } from "./duplicateremovalsuccessDialog.vue?vue&type=template&id=c6b451b8&scoped=true&"
import script from "./duplicateremovalsuccessDialog.vue?vue&type=script&lang=js&"
export * from "./duplicateremovalsuccessDialog.vue?vue&type=script&lang=js&"
import style0 from "./duplicateremovalsuccessDialog.vue?vue&type=style&index=0&id=c6b451b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b451b8",
  null
  
)

export default component.exports